import { cn } from "@istari-frontend/shared";
import { ComponentProps } from "react";

export function ControlTagChip({
  tag,
  className,
  ...props
}: ComponentProps<"span"> & { tag: { name: string; displayColor?: string | null } }) {
  return (
    <span
      className={cn("text-foreground flex items-center rounded-full border px-2 py-0.5 text-xs font-medium", className)}
      style={{ borderColor: tag.displayColor ?? undefined }}
      {...props}
    >
      {tag.name}
    </span>
  );
}
